import { createSlice, createAsyncThunk, type PayloadAction } from '@reduxjs/toolkit';
import type { Dayjs } from 'plugins/dayjs';
import type { AsistenciaKinder } from 'models/asistencia_kinder_model';
import {
  getKinderAssistanceByDate,
  saveAssistance,
} from 'repositories/asistencia_kinder_repository';

interface AsistenciaKinderState {
  asistenciaKinder: AsistenciaKinder;
  loading: boolean;
  error: string | null;
}

const initialState: AsistenciaKinderState = {
  asistenciaKinder: [],
  loading: false,
  error: null,
};

export const getKinderAssistance = createAsyncThunk<AsistenciaKinder, Dayjs | undefined, { rejectValue: string }>(
  'asistenciaKinder/getKinderAssistance',
  async (date, { rejectWithValue }) => {
    try {
      return ((await getKinderAssistanceByDate(date)) ?? []) as AsistenciaKinder;
    } catch {
      return rejectWithValue('Error al cargar asistencia kinder');
    }
  },
);

export const updateAssistance = createAsyncThunk(
  'asistenciaKinder/updateAssistance',
  async (
    { data, date }: { data: AsistenciaKinder; date?: string },
    { rejectWithValue },
  ) => {
    try {
      await saveAssistance(data, date);
    } catch {
      return rejectWithValue('Error al guardar asistencia');
    }
  },
);

export const asistenciaKinderSlice = createSlice({
  name: 'asistenciaKinder',
  initialState,
  reducers: {
    setKinderAssistance: (state, action: PayloadAction<AsistenciaKinder>) => {
      state.asistenciaKinder = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getKinderAssistance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getKinderAssistance.fulfilled, (state, action) => {
        state.loading = false;
        state.asistenciaKinder = action.payload;
      })
      .addCase(getKinderAssistance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setKinderAssistance } = asistenciaKinderSlice.actions;
export default asistenciaKinderSlice.reducer;
